var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaplogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1A1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7695 21.9685C14.2114 19.0365 12.5236 18.4328 11.2252 16.0182C10.2298 14.1211 12.6967 13 15.4232 13C18.1931 13 19.6212 13.9055 20.5301 15.5439C21.4822 17.2255 21.1793 18.7778 22.3478 21.2786L22.391 21.1924C23.9491 18.2604 22.7806 17.3549 23.9491 15.199C24.8146 13.6468 25.8966 13 27.5412 13C29.229 13 30.0513 14.2504 29.3589 15.5439C28.3635 17.3118 26.4592 18.2604 24.8579 21.1924L22.2612 25.9784C21.0927 28.0049 18.7557 27.7894 17.8901 25.9784L15.7695 21.9685Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaplogo);
export default __webpack_public_path__ + "static/media/maplogo.1fb74888e9ffd0741195b8a25d9940aa.svg";
export { ForwardRef as ReactComponent };